import axios from 'axios';
import store from 'store';
import { LSGO_AUTHENTICATION_BASE_URL } from 'config/lsgoAuthentication';
import { isFramed } from './lsgoAuthEmbedSession';
import { startLsgoAuthenticationLogin } from './lsgoAuthenticationRedirectFlow';

/**
 * Opening LifeSkillsGO directly after signing in through a Sentral / School
 * Bytes iframe or link: lsgo-authentication remembers that last SIS sign-in
 * (provider + school, no token; GET /sso/last, an HttpOnly cookie where the
 * browser keeps third-party cookies) and this sends the visitor straight to
 * that school's provider, a full sign-in with no clicks. The provider
 * decides who is signed in, so a shared computer gets whoever is signed in
 * to the SIS now.
 *
 * Only on the sign-in page with nothing else in progress, at top level, and
 * once per tab: if that sign-in doesn't complete, the normal page stays.
 * An LSGO sign-out clears the record (auth's /token/revoke).
 */

const TRIED_KEY = 'lsgo_last_sis_sign_in_tried';

export async function tryLastSisSignIn() {
    if (isFramed() || store.getState().auth?.isAuthenticated) return false;
    const { pathname, search } = window.location;
    const query = new URLSearchParams(search);
    if (pathname !== '/' || query.get('auth_method') || query.get('code') || query.get('_rt')) return false;
    try {
        if (window.sessionStorage.getItem(TRIED_KEY)) return false;
        window.sessionStorage.setItem(TRIED_KEY, '1');
    } catch {
        return false; // can't record the attempt: don't risk a loop
    }

    let last;
    try {
        ({ data: last } = await axios.get(`${LSGO_AUTHENTICATION_BASE_URL}/sso/last`, { withCredentials: true }));
    } catch {
        return false;
    }
    if (!last?.idp || !last?.tenant || store.getState().auth?.isAuthenticated) return false;

    await startLsgoAuthenticationLogin(query.get('redirectUri') || '/teacher', { idp: last.idp, tenant: last.tenant });
    return true;
}
